import { render } from "./klb-q5.vue?vue&type=template&id=113482ee&scoped=true"
import script from "./klb-q5.vue?vue&type=script&lang=js"
export * from "./klb-q5.vue?vue&type=script&lang=js"

import "./klb-q5.vue?vue&type=style&index=0&id=113482ee&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113482ee"]])

export default __exports__